export default __webpack_public_path__ + "static/media/produto.f68f2603.png";